import webAPIHelper from "../common/utils/webAPIHelper";
import { GetSessionId } from "../common/utils/sessionHelper";

const controller = "/Productos";

let cachedProducts = null;

export async function CargarTodosLosProductos() {
  if (cachedProducts) return cachedProducts;
  cachedProducts = await InvocarProductos(`${controller}?sessionId=${GetSessionId()}`);
  return cachedProducts;
}

export async function ProductosPorCategoria(idCategoria) {
  const allProducts = await CargarTodosLosProductos();
  if (!allProducts) return [];
  return allProducts.filter(p => p.idCategoria === idCategoria);
}

export async function ProductosBuscar(textoBuscar) {
  const allProducts = await CargarTodosLosProductos();
  if (!allProducts) return [];
  const lowerTexto = textoBuscar.toLowerCase();
  return allProducts.filter(p => 
    (p.descripcion && p.descripcion.toLowerCase().includes(lowerTexto)) ||
    (p.nombre && p.nombre.toLowerCase().includes(lowerTexto))
  );
}

async function InvocarProductos(url) {
  const appsvc = new webAPIHelper();
  const response = await appsvc.Get(url);
  if (response === null) return null;

  return response;
}
